module.exports = __webpack_public_path__ + "static/media/mapbg.c608510e.jpg";